/*
 * Branded 404 page — neon pink SH crest on black.
 * Google gets a proper 404 signal via <meta name="robots" content="noindex"> in
 * the mount effect (we can't set an HTTP status from a static SPA, but we set
 * `soft-404` friendly signals so crawlers don't waste index quota on it).
 */
import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const SH_LOGO =
  "https://customer-assets.emergentagent.com/job_soho69-events/artifacts/zk7tuj6l_IMG_1952.jpg";

export default function NotFound() {
  useEffect(() => {
    document.title = "Lost in the Rave · Soho69";
    // Soft-404 signal for crawlers.
    let m = document.querySelector('meta[name="robots"]');
    if (!m) {
      m = document.createElement("meta");
      m.setAttribute("name", "robots");
      document.head.appendChild(m);
    }
    const prev = m.getAttribute("content");
    m.setAttribute("content", "noindex,nofollow");
    return () => {
      if (prev) m.setAttribute("content", prev);
      else m.remove();
    };
  }, []);

  return (
    <main
      data-testid="not-found-page"
      className="min-h-screen w-full flex flex-col items-center justify-center bg-black text-white px-6 text-center"
      style={{
        background:
          "radial-gradient(ellipse at 50% 40%, rgba(255,27,141,0.18) 0%, #0a0014 55%, #000 100%)",
      }}
    >
      <img loading="lazy" decoding="async"         src={SH_LOGO}
        width="112"
        height="112"
        alt="Soho69"
        className="w-24 h-24 sm:w-28 sm:h-28 rounded-full border-2 border-neon object-cover"
        style={{ boxShadow: "0 0 40px rgba(255,27,141,0.6), 0 0 80px rgba(255,27,141,0.3)" }}
      />
      <div className="mt-8 font-heading text-6xl sm:text-7xl md:text-8xl uppercase leading-[0.9] tracking-tight">
        <span className="text-white">4</span>
        <span className="text-neon">0</span>
        <span className="text-white">4</span>
      </div>
      <h1 className="mt-6 font-heading uppercase text-2xl sm:text-3xl md:text-4xl tracking-widest">
        Lost in the <span className="text-neon">Rave?</span>
      </h1>
      <p className="mt-3 max-w-md text-sm sm:text-base text-white font-semibold leading-relaxed">
        This page doesn&apos;t exist. Somebody switched the map for a bottle
        menu — happens to the best of us.
      </p>
      <Link
        to="/"
        data-testid="not-found-home"
        className="mt-9 inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-bold text-black uppercase tracking-[0.28em] text-xs sm:text-sm transition active:scale-[0.98]"
        style={{
          background:
            "linear-gradient(135deg,#FF1B8D 0%,#FF6BC6 50%,#FF1B8D 100%)",
          boxShadow:
            "0 0 32px rgba(255,27,141,0.65), 0 0 60px rgba(255,27,141,0.35)",
        }}
      >
        ← Back to the party
      </Link>
      <a
        href="mailto:soho69tenerife@gmail.com"
        className="mt-6 text-[11px] uppercase tracking-widest text-white/70 hover:text-neon"
        data-testid="not-found-support"
      >
        Need help? soho69tenerife@gmail.com
      </a>
    </main>
  );
}
